import { schema } from '@/app/modules/Auth/pages/management/FeaturePackageMiniPos/constant';

// const PERMISSION = Object.entries(schema).reduce((acc, [group, children]) => {
//   children.forEach(child => {
//     acc[`${group}_${child}`.toUpperCase()] = `${group}.${child}`;
//   });

//   return acc;
// }, {});

export const PERMISSION = Object.freeze({
  // REPORT
  REPORT_SALES: 'report.sales',

  // PAYMENT
  PAYMENT_CASH: 'payment.cash',
  PAYMENT_PROMPTPAY: 'payment.promptpay',
  PAYMENT_CREDIT_CARD: 'payment.credit_card',

  // POS MANAGE
  POS_MANAGE_PRODUCT: 'pos_manage.product',
  POS_MANAGE_COUPON: 'pos_manage.coupon',
  POS_MANAGE_BRANCHES: 'pos_manage.branches_manage',

  // SALE TYPE
  SALE_TYPE_DINEIN: 'sale_type.dinein',
  SALE_TYPE_TAKEAWAY: 'sale_type.takeaway',
  SALE_TYPE_DELIVERY: 'sale_type.delivery',
  SALE_TYPE_OPENBILL: 'sale_type.openbill'
});
export default PERMISSION;
